/**
 * PrintModeBridge — branche `beforeprint` / `afterprint` une fois pour toute
 * l'application (UPT-2049), monté dans ClientProviders.
 *
 * L'entrée en mode impression y est enveloppée dans `flushSync` : le navigateur
 * lance la mise en page d'impression juste après `beforeprint`, le rendu lecture
 * (et l'empilement des onglets) doit donc être terminé à ce moment-là.
 */
import { useEffect } from 'react';
import { flushSync } from 'react-dom';
import { enterPrintMode, installPrintListeners } from './printModeStore';
import type { PrintEnv } from './printModeStore';

function enterSynchronously(env: PrintEnv): void {
  try {
    flushSync(() => {
      enterPrintMode(env);
    });
  } catch {
    // flushSync refusé (rendu en cours) : l'état est posé quand même, React rattrape au prochain tour.
    enterPrintMode(env);
  }
}

export function PrintModeBridge(): null {
  useEffect(() => installPrintListeners(undefined, enterSynchronously), []);
  return null;
}

export default PrintModeBridge;
